import React, { useContext } from 'react';
import proptypes from 'prop-types';
import { QueryProvider } from '@thd-nucleus/data-sources';
import { SponsoredUniversalBanner } from '@thd-olt-component-react/sponsored-content';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { HomepageContext } from './context/HomepageContext';
import { CUSTOMER_TYPES } from '../utils';

const { string } = proptypes;

export function SponsoredBanner(props) {
  const {
    id,
    schema,
  } = props;

  const { customerType } = useContext(HomepageContext);
  const isB2B = customerType === CUSTOMER_TYPES.B2B;

  return (
    <ErrorBoundary name="sponsored-banner">
      <QueryProvider cacheKey={id}>
        <SponsoredUniversalBanner
          bannerType="standard"
          enableRoundedCorners
          schema={isB2B ? 'hp_sponsored_auth' : schema}
        />
      </QueryProvider>
    </ErrorBoundary>
  );
}

SponsoredBanner.propTypes = {
  id: string,
  schema: string
};

SponsoredBanner.defaultProps = {
  id: undefined,
  schema: undefined
};
